import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { connect } from 'react-redux'

import Request from './Request'
import Response from './Response'
import Authorization from './Authorization'
import Header from './Header'
import { getRouteLink } from '../../helpers/helpers'

// Presentational Component
const Route = ({ route, route: { request }, responses }) => {
	const response = responses[route.apiResponse]
	const hasRequestArgs = request.fields !== undefined && request.fields.length > 0
	const path = route.path[0]

	const renderRateLimit = rateLimit => {
		switch (rateLimit.Rate) {
			case 5:
				return 'Extreme'
			case 25:
				return 'Heavy'
			case 75:
				return 'Medium'
			default:
				return 'Light'
		}
	}

	return (
		<div className="route-item">
			<div className="route-head">
				<div className="head-left">
					{/* Internal route only warning */}
					{request.isInternal && <div className="internal-only">INTERNAL ONLY</div>}

					{/* Paths */}
					<div className="paths">
						<span id={getRouteLink(route)}></span>
						{route.verbs.map(v => (
							<h3 className="path" key={`${v}${path}`}>
								<span className="verbs">{v}</span> {path}
							</h3>
						))}
					</div>
					{/* Summary */}
					<p>{request.summary}</p>

					{/* Notes */}
					{request.notes && (
						<p
							className="notes"
							dangerouslySetInnerHTML={{ __html: `Notes: ${request.notes}` }}
						></p>
					)}

					{/* Headers */}
					{request.headers && <Header headers={request.headers} />}
				</div>

				<div className="head-right">
					{/* Authorization */}
					{request.isAuthorizationRequired && (
						<Authorization
							roles={request.authorizationRoles}
							methods={request.authorizationMethods}
						/>
					)}

					{/* Rate Limit */}
					{route.rateLimit && (
						<div className="meta">
							<Link to="/getting-started/rate-limiting" className="heading">
								Rate Limit <i className="fa fa-info-circle"></i>
							</Link>
							<span className="role member">{renderRateLimit(route.rateLimit)}</span>
						</div>
					)}

					{/* Batchable */}
					{request.isBatchable && (
						<div className="meta">
							<Link to="/getting-started/batch-requests" className="heading">
								Batchable <i className="fa fa-info-circle"></i>
							</Link>
							<span className="role manager">Yes</span>
						</div>
					)}
				</div>
			</div>

			{/* Request */}
			{hasRequestArgs && <Request request={request} />}

			{/* Response */}
			<Response response={response} />
		</div>
	)
}

const mapStateToProps = (state, ownProps) => {
	return {
		responses: state.api.responses,
	}
}

Route.propTypes = {
	route: PropTypes.object.isRequired,
	responses: PropTypes.object.isRequired,
}

export default connect(mapStateToProps)(Route)



// WEBPACK FOOTER //
// ./src/components/api/Route.js